/**
 * fetchJson — shared throw-on-failure contract for MrPibb's REST calls.
 *
 * Extracted after fetchConversations (useConversationSessions.ts) and
 * fetchSuggestions.ts both independently implemented "no token -> throw,
 * non-ok response -> throw with status" for the loadingWorkspace boot
 * phase's Promise.all to work correctly (see startup-sequencing spec §4).
 * Any future REST call the boot sequence needs to await should use this
 * instead of re-implementing the same two checks a third time.
 */

/**
 * Fetch JSON from a URL with a bearer token, throwing on any failure
 * instead of silently swallowing it. `resourceName` is used only to make
 * the thrown error message identify which call failed.
 */
export async function fetchJson<T>(url: string, token: string | null, resourceName: string): Promise<T> {
  if (!token) throw new Error(`Unable to fetch ${resourceName}: no valid auth token`);

  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    throw new Error(`Unable to fetch ${resourceName}: server responded ${res.status}`);
  }
  return res.json();
}
